module.exports = __webpack_public_path__ + "static/media/img-planes.484ceba5.jpg";